/**
 * Nuclear "hard clean": fully reload the webview to guarantee a clean slate.
 * The JWT lives in localStorage, so the user remains authenticated after reload.
 * Any unsaved in-progress input is intentionally discarded.
 */
export const hardReload = (): void => {
  window.location.reload();
};
